import { PERMISSION_TYPES } from './CommonConstants';

export const TICKET_STATUS = {
  NEW: 'NEW',
  PENDING: 'PENDING',
  SOLVED: 'SOLVED',
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  HOLD: 'HOLD',
};

export const TICKET_PRIORITY = {
  LOW: 'LOW',
  NONE: 'NONE',
  URGENT: 'URGENT',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
};

export const UPDATE_DATA_TYPES = {
  ASSIGNERS: 'assigners',
  COMPANIES: 'companies',
  REQUESTER: 'requester',
  STATUS: 'status',
  PRIORITY: 'priority',
  SUBJECT: 'subject',
  DESCRIPTION: 'description',
  TYPE: 'type',
};

export const COMMENT_TYPES = {
  reply: 'Reply',
  note: 'Note',
};

export const TICKET_STATUS_FILTER_OPTIONS = [
  {
    value: TICKET_STATUS.NEW,
    displayName: 'New',
  },
  {
    value: TICKET_STATUS.PENDING,
    displayName: 'Pending',
  },
  {
    value: TICKET_STATUS.SOLVED,
    displayName: 'Solved',
  },
  {
    value: TICKET_STATUS.OPEN,
    displayName: 'Open',
  },
  {
    value: TICKET_STATUS.CLOSED,
    displayName: 'Closed',
  },
  {
    value: TICKET_STATUS.HOLD,
    displayName: 'Hold',
  },
];

export const TICKET_CHANNEL_FILTER_OPTIONS = [
  {
    value: 'WEB',
    displayName: 'Web',
  },
  {
    value: 'EMAIL',
    displayName: 'Email',
  },
  {
    value: 'API',
    displayName: 'API',
  },
  {
    value: 'CHAT',
    displayName: 'Chat',
  },
];

export const TICKET_PRIORITY_FILTER_OPTIONS = [
  {
    value: null,
    displayName: 'None',
    flagState: 'none',
  },
  {
    value: TICKET_PRIORITY.LOW,
    displayName: 'Low',
    flagState: 'low',
  },
  {
    value: TICKET_PRIORITY.MEDIUM,
    displayName: 'Medium',
    flagState: 'normal',
  },
  {
    value: TICKET_PRIORITY.HIGH,
    displayName: 'High',
    flagState: 'high',
  },
  {
    value: TICKET_PRIORITY.URGENT,
    displayName: 'Urgent',
    flagState: 'urgent',
  },
];

export const TICKET_SUMMARY_DAYS_PERIOD = 30;

export const TICKET_STATUS_MAPPING = {
  new: { color: 'yellow', status: 'New' },
  open: { color: 'blue', status: 'Open' },
  pending: { color: 'purple', status: 'Pending' },
  solved: { color: 'green', status: 'Solved' },
  closed: { color: 'grey', status: 'Closed' },
  hold: { color: 'red', status: 'Hold' },
};

export const TICKET_SOURCES = {
  ZENDESK: {
    value: 'ZENDESK',
    displayName: 'Zendesk',
  },
  FRESHDESK: {
    value: 'FRESHDESK',
    displayName: 'Freshdesk',
  },
  INTERCOM: {
    value: 'INTERCOM',
    displayName: 'Intercom',
  },
  JIRA: {
    value: 'JIRA',
    displayName: 'Jira',
  },
  HUBSPOT: {
    value: 'HUBSPOT',
    displayName: 'Hubspot',
  },
  VELARIS: {
    value: 'VELARIS',
    displayName: 'Velaris',
  },
  CONNECT: {
    value: 'CONNECT',
    displayName: 'Connect',
  },
};

export const TICKET_CHANNELS = {
  WEB: 'WEB',
  API: 'API',
  EMAIL: 'EMAIL',
  CHAT: 'CHAT',
  PHONE: 'PHONE',
  PORTAL: 'PORTAL',
};

export const TICKET_PRIORITY_VALUE_DISPLAY_MAPPING = {
  null: 'None',
  [TICKET_PRIORITY.LOW]: 'Low',
  [TICKET_PRIORITY.MEDIUM]: 'Medium',
  [TICKET_PRIORITY.HIGH]: 'High',
  [TICKET_PRIORITY.URGENT]: 'Urgent',
};

export const TICKET_ACTIVITY_TYPE = {
  UPDATE: 'update',
  REPLAY: 'comment',
};

export const TICKET_ACTIVITY_SORTING_TYPE = {
  NEWEST: 'newest',
  OLDEST: 'oldest',
};

export const TICKET_DEFAULT_PAGE_SIZE = 20;
export const TICKET_DEFAULT_PAGE = 1;

export const ROUTINE_EVENT = {
  TRIGGER: 'TRIGGER',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const CUSTOM_FILTERS = {
  ALL_TICKETS: 'allTickets',
  MY_ASSIGNED: 'myAssignedOnly',
  UNASSIGNED: 'unassignedOnly',
  MENTIONED: 'mentionedOnly',
  CREATED_BY_ME: 'createdByMeOnly',
};

export const QUICK_FILTERS = [
  {
    label: 'My Assigned',
    filterParam: CUSTOM_FILTERS.MY_ASSIGNED,
  },
  {
    label: 'All Tickets',
    filterParam: CUSTOM_FILTERS.ALL_TICKETS,
  },
  {
    label: 'Created by me',
    filterParam: CUSTOM_FILTERS.CREATED_BY_ME,
  },
  {
    label: '@mentions',
    filterParam: CUSTOM_FILTERS.MENTIONED,
  },
  {
    label: 'Unassigned',
    filterParam: CUSTOM_FILTERS.UNASSIGNED,
  },
];

export const TICKET_MENU_TAB_KEYS = {
  DETAILS: 'details',
  ACTIVITY: 'activity',
  COMMENTS: 'comments',
};

export const TICKET_MENU_TABS = [
  {
    key: TICKET_MENU_TAB_KEYS.DETAILS,
    label: 'Details',
  },
  {
    key: TICKET_MENU_TAB_KEYS.ACTIVITY,
    label: 'Activity',
  },
  {
    key: TICKET_MENU_TAB_KEYS.COMMENTS,
    label: 'Comments',
  },
];

export const STATUS_ICON_CLASS_MAPPING = {
  [TICKET_STATUS.NEW]: 'comm-status-new',
  [TICKET_STATUS.PENDING]: 'comm-status-pending comm-time',
  [TICKET_STATUS.SOLVED]: 'comm-status-completed',
  [TICKET_STATUS.OPEN]: 'comm-status-open',
  [TICKET_STATUS.CLOSED]: 'comm-status-closed',
  [TICKET_STATUS.HOLD]: 'comm-status-on-hold',
};

export const TICKET_PERMISSIONS = {
  VIEW: [
    PERMISSION_TYPES.ADMINISTRATOR,
    PERMISSION_TYPES.MANAGER,
    PERMISSION_TYPES.NORMAL_USER,
    PERMISSION_TYPES.VIEWER,
  ],
  EDIT: [
    PERMISSION_TYPES.ADMINISTRATOR,
    PERMISSION_TYPES.MANAGER,
    PERMISSION_TYPES.NORMAL_USER,
  ],
};

export const TICKET_ENTITY_TYPE = {
  ORGANIZATION: 'ORGANIZATION',
  ACCOUNT: 'ACCOUNT',
};

export const TICKET_CHANNEL_MAPPING = {};
export const TICKET_ORIGIN_MAPPING = {};

export const TICKET_UPDATE_ATTR = {
  ASSIGNEE_ID: 'assigneeId',
  STATUS: 'status',
  PRIORITY: 'priority',
  ENTITIES: 'entities',
  SUBJECT: 'subject',
};

export const UPDATE_ATTR_DISPLAY_NAME = {
  [TICKET_UPDATE_ATTR.ASSIGNEE_ID]: 'Assignee',
  [TICKET_UPDATE_ATTR.STATUS]: 'Status',
  [TICKET_UPDATE_ATTR.PRIORITY]: 'Priority',
  [TICKET_UPDATE_ATTR.ENTITIES]: 'Linked Entity',
  [TICKET_UPDATE_ATTR.SUBJECT]: 'Subject',
};

export const MAX_FILE_SIZE = 2; // 2mb
